import React from 'react';

const CommonSelectWithInput = ({selectData, onChange, onSelectChange, value, svalue, type, label, name, placeholder, error, selectName}) => {
    return (
        <div className="form-group col-md-6 row">

            <div className=" col-4">
                <label htmlFor="inputEmail4">{label} {require && <span className="text-danger">*</span>}</label>
                <div className="rld-single-select">
                    <select id={selectName}
                            name={selectName}
                            className="select single-select form-control"
                            onChange={onSelectChange}
                            value={svalue}
                    >
                        {selectData && selectData.map(unit => <option
                            value={unit._id}
                            key={unit._id}
                        >{unit.name}</option>)}
                    </select>
                </div>
            </div>
            <div className="col-8 mt-auto">

                <input type={type} className="form-control" name={name} id={name} placeholder={placeholder}
                       onChange={onChange} value={value}/>
            </div>
            {error && <span className="text-danger text-center ml-0 ml-lg-3">{error}</span>}
        </div>
    );
};

export default CommonSelectWithInput;